<script setup>
import { onMounted, ref } from 'vue'
import TeamPlayerBlock from '../team/TeamPlayerBlock.vue'
import TeamPlayersStats from '../team/TeamPlayersStats.vue'

const { mode, shortStats } = defineProps({
    mode: {
        type: String,
        default: null,
    },
    shortStats: {
        type: Boolean,
        default: false,
    },
})
const topPlayers = ref([])
const allPlayers = route('players') + (mode === '3' ? '?pttf=' + mode : '')

onMounted(() => {
    let url = route('api.team.stats.top.players')
    if (mode) {
        url += '?' + new URLSearchParams({mode}).toString()
    }

    fetch(url)
        .then(response => response.json())
        .then(data => {
            topPlayers.value = data.data.players
        })
})

function getPlayerBlockTitle(index) {
    switch (index) {
        case 0: return 'Атака'
        case 1: return 'Защита'
        case 2: return 'Вратарь'
        default: return ''
    }
}
</script>

<template>
<h2 class="mt-4 mb-0">{{ $t('team.best_players') }}</h2>
<div class="small mb-2">{{ $t('common.for_all_times') }}</div>
<masonry-wall
    v-if="topPlayers.length"
    class="mb-4"
    :items="topPlayers"
    :max-columns="3"
    :gap="24"
>
    <template #default="{ item, index }">
        <team-player-block :player="item" :title="getPlayerBlockTitle(index)"/>
    </template>
</masonry-wall>
<div v-else class="mb-4">{{ $t('common.empty_data') }}</div>

<team-players-stats
    :title="$t('player.players_stats')"
    :subtitle="$t('common.for_all_times')"
    :show-free="true"
    :mode="mode"
    :short-stats="shortStats"
/>
<div class="text-center mt-2">
    <a :href="allPlayers" class="btn btn-all btn-outline-light btn-gradient">
        {{ $t('player.all_players') }}
    </a>
</div>
</template>
